import { supabase } from "../supabaseClient";

export const upsertTeamScoresVerification = async ({
  tournamentId,
  teamId,
  isVerified,
}) => {
  const now = new Date().toISOString();
  const { error } = await supabase.from("verificationStates").upsert(
    isVerified
      ? {
          tournamentId,
          entityType: "scores",
          entityId: teamId,
          isVerified: true,
          verifiedAt: now,
          verifiedBy: null,
          unverifiedAt: null,
          unverifiedBy: null,
        }
      : {
          tournamentId,
          entityType: "scores",
          entityId: teamId,
          isVerified: false,
          verifiedAt: null,
          unverifiedAt: now,
          unverifiedBy: null,
        },
    { onConflict: "tournamentId,entityType,entityId" }
  );
  if (error) throw error;
};
